// Placeholder Page - Full implementation in Phase 5
export default function AdminPage() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold text-white mb-6">Admin Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="card">
          <p className="text-dark-400 text-sm">Total Users</p>
          <p className="text-3xl font-bold text-white">0</p>
        </div>
        <div className="card">
          <p className="text-dark-400 text-sm">Active Subscriptions</p>
          <p className="text-3xl font-bold text-white">0</p>
        </div>
        <div className="card">
          <p className="text-dark-400 text-sm">Monthly Revenue</p>
          <p className="text-3xl font-bold text-white">$0</p>
        </div>
      </div>
    </div>
  )
}
